import { lazy } from "react";

// Lazy Loaded Components
const SellerInvoiceAll = lazy(
  () => import("../components/invoice/SellerInvoiceAll"),
);
const PaymentAdvicePrintSeller = lazy(
  () => import("../components/paymentAdvice/view/PaymentAdvicePrintSeller"),
);
const ReceivedPOPrintSeller = lazy(
  () => import("../components/purchaseOrder/view/ReceivedPOPrintSeller"),
);
const ReturnPOPrintSeller = lazy(
  () => import("../components/purchaseOrder/view/ReturnPOPrintSeller"),
);
const OrderRequisitionSeller = lazy(
  () =>
    import("../containers/orderRequisition/OrderRequisitionListSellerContainer"),
);
const SellerPaymentAdviceListContainer = lazy(
  () => import("../containers/paymentAdvice/SellerPaymentAdviceListContainer"),
);
const DuplicateSellerProductContainer = lazy(
  () => import("../containers/product/DuplicateSellerProductContainer"),
);
const CreateProductSellerContainer = lazy(
  () => import("../containers/product/CreateProductSellerContainer"),
);
const EditSellerProductContainer = lazy(
  () => import("../containers/product/EditSellerProductContainer"),
);
const ManageSellerProducts = lazy(
  () => import("../containers/product/ManageSellerProducts"),
);
const ManageSellerCampaignProductsContainer = lazy(
  () => import("../containers/campaign/ManageSellerCampaignProductsContainer"),
);
const ModifySellerProductListContainer = lazy(
  () => import("../containers/campaign/ModifySellerProductListContainer"),
);
const SellerCampaignListContainer = lazy(
  () => import("../containers/campaign/SellerCampaignListContainer"),
);
const SellerReceivedPOListContainer = lazy(
  () => import("../containers/purchaseOrder/SellerReceivedPOListContainer"),
);
const SellerReturnPOListContainer = lazy(
  () => import("../containers/purchaseOrder/SellerReturnPOListContainer"),
);
const ReportSellerContainer = lazy(
  () => import("../containers/report/ReportSellerContainer"),
);
const BankAccountsListContainer = lazy(
  () => import("../containers/seller/BankAccountsListContainer"),
);
const BusinessInfoNewContainer = lazy(
  () => import("../containers/seller/BusinessInfoNewContainer"),
);
const CancelSellerOrdersListContainer = lazy(
  () => import("../containers/seller/CancelSellerOrdersListContainer"),
);
const CreateSellerCommissionPercentageContainer = lazy(
  () =>
    import("../containers/seller/CreateSellerCommissionPercentageContainer"),
);
const EditSellerCommissionPercentageContainer = lazy(
  () => import("../containers/seller/EditSellerCommissionPercentageContainer"),
);
const ManageOrderContainer = lazy(
  () => import("../containers/seller/ManageOrderContainer"),
);
const ReturnAddressContainer = lazy(
  () => import("../containers/seller/ReturnAddressContainer"),
);
const ReturnSellerOrdersListContainer = lazy(
  () => import("../containers/seller/ReturnSellerOrdersListContainer"),
);
const SellerCommissionPercentageListContainer = lazy(
  () => import("../containers/seller/SellerCommissionPercentageListContainer"),
);
const SellerReturnPolicyContainer = lazy(
  () => import("../containers/seller/SellerReturnPolicyContainer"),
);
const ShippingProviderContainer = lazy(
  () => import("../containers/seller/ShippingProviderContainer"),
);
const WarehouseAddressContainer = lazy(
  () => import("../containers/seller/WarehouseAddressContainer"),
);
const SellerHomeContainer = lazy(
  () => import("../containers/sellerHome/SellerHomeContainer"),
);
const ChangeSellerPasswordContainer = lazy(
  () => import("../containers/sellerProfile/ChangeSellerPasswordContainer"),
);
const EditSellerProfileContainer = lazy(
  () => import("../containers/sellerProfile/EditSellerProfileContainer"),
);
const SellerProfileContainer = lazy(
  () => import("../containers/sellerProfile/SellerProfileContainer"),
);
const CreateShopContainer = lazy(
  () => import("../containers/shop/CreateShopContainer"),
);
const AllStoreBannerListSellerContainer = lazy(
  () => import("../containers/store/AllStoreBannerListSellerContainer"),
);
const CreateSellerStoreBannerContainer = lazy(
  () => import("../containers/store/CreateSellerStoreBannerContainer"),
);
const EditSellerStoreBannerContainer = lazy(
  () => import("../containers/store/EditSellerStoreBannerContainer"),
);
const SellerAccountsReviewContainer = lazy(
  () => import("../containers/seller/SellerAccountsReviewContainer"),
);

export const sellerDashboardRoutes = [
  { path: "/SellerHome", component: SellerHomeContainer },
  { path: "/CreateShop", component: CreateShopContainer },
  { path: "/CreateProductSeller", component: CreateProductSellerContainer },
  { path: "/EditSellerProduct/:id", component: EditSellerProductContainer },
  {
    path: "/DuplicateSellerProduct/:id",
    component: DuplicateSellerProductContainer,
  },
  { path: "/SellerProfile", component: SellerProfileContainer },
  { path: "/EditSellerProfile", component: EditSellerProfileContainer },
  {
    path: "/ChangeSellerPassword/:id",
    component: ChangeSellerPasswordContainer,
  },
  { path: "/BusinessInformation", component: BusinessInfoNewContainer },
  { path: "/ShippingProvider", component: ShippingProviderContainer },
  { path: "/WarehouseAddress", component: WarehouseAddressContainer },
  { path: "/ReturnAddress", component: ReturnAddressContainer },
  { path: "/ReturnPolicy", component: SellerReturnPolicyContainer },
  { path: "/BankAccount", component: BankAccountsListContainer },
  { path: "/AccountsReview", component: SellerAccountsReviewContainer },
  { path: "/ManageOrder", component: ManageOrderContainer },
  { path: "/CancelSellerOrders", component: CancelSellerOrdersListContainer },
  { path: "/ReturnSellerOrders", component: ReturnSellerOrdersListContainer },
  {
    path: "/CreateCommissionPercentage",
    component: CreateSellerCommissionPercentageContainer,
  },
  {
    path: "/EditCommissionPercentage",
    component: EditSellerCommissionPercentageContainer,
  },
  {
    path: "/CommissionPercentageList",
    component: SellerCommissionPercentageListContainer,
  },
  { path: "/SellerInvoice", component: SellerInvoiceAll },
  { path: "/SellerInvoiceAll", component: SellerInvoiceAll },
  { path: "/Seller-Order-Requisition", component: OrderRequisitionSeller },
  { path: "/Manage-Seller-Products", component: ManageSellerProducts },
  {
    path: "/CreateSellerStoreBanner",
    component: CreateSellerStoreBannerContainer,
  },
  {
    path: "/SellerStoreBannerList",
    component: AllStoreBannerListSellerContainer,
  },
  {
    path: "/UpdateSellerStoreBanner",
    component: EditSellerStoreBannerContainer,
  },
  { path: "/ReportSeller", component: ReportSellerContainer },
  { path: "/SellerCampaignList", component: SellerCampaignListContainer },
  {
    path: "/Modify-Seller-Campaign-ProductsList",
    component: ModifySellerProductListContainer,
  },
  {
    path: "/Manage-Seller-Campaign-ProductsList",
    component: ManageSellerCampaignProductsContainer,
  },
  { path: "/SellerReceivedPOList", component: SellerReceivedPOListContainer },
  { path: "/SellerReturnPOList", component: SellerReturnPOListContainer },
  {
    path: "/SellerPaymentAdviceList",
    component: SellerPaymentAdviceListContainer,
  },
  { path: "/PrintSellerPaymentAdvice", component: PaymentAdvicePrintSeller },
  { path: "/PrintSellerReceivedPO", component: ReceivedPOPrintSeller },
  { path: "/PrintSellerReturnPO", component: ReturnPOPrintSeller },
];
